import React, { useState } from "react";
import PremiumBreakUpEndorsement from "./PremiumBreakUpEndorsement";
import { Button, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";
import Colors from "../../theme/colors.json";
import CommissionInfoEndorsement from "./CommissionInfoEndorsement";
import {
  COMMISSION_STATUS_LIST,
  REWARD_STATUS_LIST,
} from "../../constants/constants";

const useStyles = makeStyles((theme) => ({
  premiumEndorsementContainer: {
    marginBottom: "2%",
  },
  premiumEndorsementBtnContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  commonBtnStyles: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },
  commissionEndorsementContainer: {
    marginBottom: "2%",
  },
}));

const EndorsementPremium = ({
  endorsementPremium,
  setEndorsementPremium,
  endorsementCommission,
  setEndorsementCommission,
}) => {
  const classes = useStyles();

  const handleAdd = () => {
    setEndorsementPremium((prevState) => {
      return [
        ...prevState,
        {
          netPremium: {
            netPremium: 0,
            gst: 0,
            gstPremium: 0,
            premiumWithGst: 0,
          },
          motorTpPremium: {
            netPremium: 0,
            gst: 0,
            gstPremium: 0,
            premiumWithGst: 0,
          },
          totalPremium: {
            totalNetPremium: 0,
            totalGstPremium: 0,
            totalPremiumWithGst: 0,
          },
          grossPremium: { grossPremiumWithGst: 0 },
          validation: false,
          reasonForEndorsement: "",
          endorsementNumber: "",
          endorsementEffectiveDate: "",
          endorsementDocument: {
            fileName: "",
            fileType: "",
            fileSize: "",
            documentId: "",
            status: "",
          },
        },
      ];
    });
    setEndorsementCommission((prevState) => {
      return [
        ...prevState,
        {
          netPremium: {
            netPremium: 0,
            commission: 0,
            commissionAmount: 0,
            reward: 0,
            rewardAmount: 0,
          },
          motorTpPremium: {
            netPremium: 0,
            commission: 0,
            commissionAmount: 0,
            reward: 0,
            rewardAmount: 0,
          },
          totalPremium: {
            totalNetPremium: 0,
            totalCommissionAmount: 0,
            totalRewardAmount: 0,
            totalReconciliationStatementFromInsurer: 0,
            totalBankReconciliationStatement: 0,
          },
          commissionStatus: COMMISSION_STATUS_LIST[0]?.value || "",
          rewardStatus: REWARD_STATUS_LIST[0]?.value || "",
          commissionAmountValidation: false,
          rewardAmountValidation: false,
          endorsementEffectiveDate: "",
          endorsementDocument: {
            fileName: "",
            fileType: "",
            fileSize: "",
            documentId: "",
            status: "",
          },
        },
      ];
    });
  };

  return (
    <div>
      <div>
        <div className={classes.premiumEndorsementBtnContainer}>
          <Button
            className={classes.commonBtnStyles}
            variant="outlined"
            color="primary"
            onClick={handleAdd}
            startIcon={<AddIcon />}
          >
            Add Premium Endorsement
          </Button>
        </div>
        <div>
          {endorsementPremium?.map((item, index) => {
            return (
              <>
                <div className={classes.premiumEndorsementContainer}>
                  <PremiumBreakUpEndorsement
                    key={index}
                    premiumDataArray={endorsementPremium}
                    setPremiumDataArray={setEndorsementPremium}
                    index={index}
                    setEndorsementCommission={setEndorsementCommission}
                  />
                </div>
                <div className={classes.commissionEndorsementContainer}>
                  <CommissionInfoEndorsement
                    key={index}
                    commissionInfoArray={endorsementCommission}
                    setCommissionInfoArray={setEndorsementCommission}
                    index={index}
                  />
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EndorsementPremium;
